var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActivityIconNew(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EE9321;}\n\t.st1{fill:#217cee;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "notification_bell-_1396_",
    className: "st1",
    d: "M355.2,348.8H144.8V200.3c0-66,52.6-99,105.2-99l0,0c52.6,0,105.2,33,105.2,99 V348.8z M276.3,423c-0.8,14.5-13.3,25.6-27.8,24.8c-13.4-0.8-24.1-11.4-24.8-24.8v-24.7h52.6V423z M407.8,299.3v-99 c0-87.9-62.3-136.7-131.5-146.5V2.3h-52.6v51.5c-69.2,9.8-131.5,58.6-131.5,146.5v99c-0.9,28.2-24.4,50.3-52.6,49.5v49.5h131.5V423 c1.3,42.3,36.6,75.5,78.9,74.2c42.3,1.3,77.6-32,78.9-74.2v-24.7h131.5v-49.5C432.2,349.6,408.6,327.4,407.8,299.3z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityIconNew);
export default __webpack_public_path__ + "static/media/activity_icon_new.f62554d5fe0895b9870775d50209bd4e.svg";
export { ForwardRef as ReactComponent };